import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';

@Component({
    selector: 'app-chat-support',
    templateUrl: './chat-support.component.html',
    styleUrls: ['./chat-support.component.scss'],
    //standalone: false
})

/**
 * @class ChatSupportComponent
 * @description Componente que representa el botón de soporte técnico a través de WhatsApp.
 * Permite a los usuarios acceder al soporte técnico de la aplicación.
 */
export class ChatSupportComponent {

  /**
   * @constructor
   * @param {Object} platformId - Identificador de la plataforma actual (navegador o servidor).
   * Se utiliza para determinar si el código se está ejecutando en el navegador.
   */
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }


  /**
   * @method goToChat
   * @description Método que redirige al usuario a la página de soporte técnico a través de WhatsApp.
   * Solo se ejecuta si el código se está ejecutando en el navegador (isPlatformBrowser).
   */
  goToChat() {
   
      
        window?.open('https://wa.link/yt04jk', '_blank')?.focus();
      
    
  }
}
